<template>
  <div class="container join-wrapper" ref="myorder">
    <van-list
      v-model="loading"
      :finished="finished"
      :finished-text="activityData.length > 0 ? '已加载完成' : ''"
      :error.sync="error"
      error-text="请求失败，点击重新加载"
      @load="onLoad"
    >
      <div class="my_join activity_join" v-for="activity in activityData" :key="activity.id" @click="$router.push({path: '/myActivity/view', query: {id: activity.id}})">
        <div class="join_info">
          <div class="title_time">
            <p class="van-ellipsis">{{activity.activitytitle}}</p>
            <div class="activity_join_info">
              <span :class="activity.isfee === 1 ? 'isfee nofree' : 'isfee'">{{activity.isfee === 1 ? '收费' : '免费'}}</span>
              <span v-if="activity.isfee === 1" class="pay_status">支付状态：{{activity.orderstatus | orderStatus}}</span>
              <span>{{activity.createtime}}</span>
            </div>
          </div>
        </div>
        <van-icon name="arrow" />
      </div>
    </van-list>
    <div class="noData" v-if="finished && activityData.length === 0">
      <img src="../../../assets/images/noData.png" alt="">
      <p>抱歉，暂无相关报名</p>
    </div>
  </div>
</template>

<script>
  import API from '../../../interface/api'
  const pageload = 10
  export default {
    name: 'myActivity',
    computed: {
      saveScrollTop: function(){
        return this.$store.state.scrollInfo.myActivity
      }
    },
    data () {
      return {
        firstLoad: true,
        loading: false,
        finished: false,
        error: false,
        index: 1,
        activityData: []
      }
    },
    created () {
      this.$toast.allowMultiple()
    },
    methods: {
      onLoad () {
        if (this.saveScrollTop && this.firstLoad) {
          this.$fetch.get(API.MEMBERACTIVITYLIST, {
            pageNum: 1,
            pageSize: this.saveScrollTop.pageSize
          }).then(response => {
            // console.log(response)
            if (response.status !== 200) {
              var msg = response.message? response.message : '我的报名获取失败，请刷新！'
              this.$toast.fail(msg)
              this.loading = false
              this.finished = true
              this.error = true
              return
            }
            this.activityData = this.activityData.concat(response.data.activitySignupList)
            this.index = this.saveScrollTop.pageNum + 1
            this.firstLoad = false
            this.loading = false
            this.$nextTick(function () {
              this.$refs.myorder.scrollTop = this.saveScrollTop.scrollTop
            })
          }).catch(error => {
            console.log(error)
            this.loading = false
            this.finished = true
            this.error = true
          })
        } else {
          this.$fetch.get(API.MEMBERACTIVITYLIST, {
            pageNum: this.index,
            pageSize: pageload
          }).then(response => {
            // console.log(response)
            if (response.data.activitySignupList.length > 0) {
              this.activityData = this.activityData.concat(response.data.activitySignupList)
              this.index += 1
              this.loading = false
              if (response.data.activitySignupList.length < pageload) {
                this.finished = true
              }
            } else {
              this.loading = false
              this.finished = true
            }
          }).catch(err => {
            console.log(err)
            this.loading = false
            this.finished = true
            this.error = true
          })
        }
      }
    },
    filters: {
      orderStatus (status) {
        switch (status)
        {
          case 0:
            return '未支付'
            break;
          case 1:
            return '已支付'
            break;
          case 2:
            return '退款中'
            break;
          case 3:
            return '已退款'
            break;
          case 4:
            return '已取消'
            break;
          case 5:
            return '已完成'
            break;
          case 6:
            return '已支付'
            break;
        }
      }
    },
    beforeRouteLeave (to, from, next) {
      if (to.path === '/myActivity/view') {
        let scrollTop = this.$refs.myorder.scrollTop
        let pagename = from.name
        let pagesize = this.index > 1 ? (this.index - 1) * pageload : this.index * pageload
        let pagenum = this.index > 1 ? this.index - 1 : this.index
        this.$store.commit('savescrollInfo', {pagename, scrollTop, pagesize, pagenum})
      } else {
        let pagename = from.name
        this.$store.commit('deletescrollInfo', pagename)
      }
      next()
    }
  }
</script>

<style lang="stylus">
</style>